import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function getOneGodo(payload) {
  return $apiClient.get(`${ApiConfig.ONEGODO}${payload}`);
}
